import { useGetGroupById } from "@/src/services/api/groups/groups.hooks";
import GroupCreationForm from "./group-creation-form";
import { useLocalSearchParams } from "expo-router";

const GroupEditForm = () => {
  const { id } = useLocalSearchParams<{ id: string }>();

  const { data } = useGetGroupById(id);
  const group = data
    ? {
        name: data.name,
        description: data.description,
        isPrivate: data.isPrivate,
        coverImageUrl: data.coverImageUrl,
        profileImageUrl: data.profileImageUrl,
        ItemId: data.ItemId,
      }
    : undefined;
  return <GroupCreationForm mode="edit" initialValues={group} />;
};

export default GroupEditForm;
